import React, { useState } from 'react';

export default function OfficeRental() {
    const [fullscreenImg, setFullscreenImg] = useState(null);

    const images = [
        { src: '/office/office1.jpg', alt: 'משרד - מבט כללי' },
        { src: '/office/office2.jpg', alt: 'חלל עבודה' },
        { src: '/office/office3.jpg', alt: 'מטבחון' },
        { src: '/office/office4.jpg', alt: 'חדר ישיבות / חדר פרטי' },
        { src: '/office/office5.jpg', alt: 'נוף' },
        { src: '/office/office6.jpg', alt: 'נוף פנורמי' },
        { src: '/office/office7.jpg', alt: 'חזית הבניין' },
        { src: '/office/office8.jpg', alt: 'מראה נוסף' },
        { src: '/office/office9.jpg', alt: 'מיקום' },
        { src: '/office/office10.jpg', alt: 'בניין' },
    ];

    const navigateImage = (direction) => {
        if (fullscreenImg === null) return;
        const currentIdx = images.findIndex(img => img.src === fullscreenImg);
        if (currentIdx === -1) return;
        const newIdx = (currentIdx + direction + images.length) % images.length;
        setFullscreenImg(images[newIdx].src);
    };

    return (
        <div className="min-h-screen bg-gray-50 text-gray-800" dir="rtl">

            {/* HEADER / HERO SECTION */}
            <div
                className="relative text-white py-28 md:py-36 px-6 text-center shadow-md overflow-hidden"
                style={{
                    backgroundImage: 'url(/office/header-bg.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center 30%',
                }}
            >
                {/* Dark overlay */}
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(10,25,60,0.72), rgba(10,25,60,0.85))' }} />

                {/* Content */}
                <div className="relative z-10">
                    <h1 className="text-4xl md:text-6xl font-bold mb-4 drop-shadow-lg">משרד פרימיום להשכרה</h1>
                    <p className="text-xl md:text-2xl text-blue-200 mb-8 drop-shadow-md">חלל עבודה מושלם, מרווח ומואר במיקום מנצח</p>
                    <a href="#contact" className="bg-yellow-500 hover:bg-yellow-400 text-blue-900 font-bold py-3 px-8 rounded-full text-lg transition-colors shadow-lg">
                        לפרטים ותיאום סיור
                    </a>
                </div>
            </div>

            <div className="max-w-6xl mx-auto px-6 py-12">

                {/* QUICK STATS / FEATURES GRID */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4">
                        <div className="text-3xl">📐</div>
                        <div>
                            <h3 className="font-bold text-lg text-blue-900">שטח המשרד</h3>
                            <p className="text-gray-600">86.27 מ"ר (64 מ"ר נטו)</p>
                        </div>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4">
                        <div className="text-3xl">🏢</div>
                        <div>
                            <h3 className="font-bold text-lg text-blue-900">חלוקת פנים</h3>
                            <p className="text-gray-600">4 חדרים פרטיים, חלל עבודה (Open Space) ומטבחון</p>
                        </div>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4">
                        <div className="text-3xl">🏙️</div>
                        <div>
                            <h3 className="font-bold text-lg text-blue-900">קומה ונוף</h3>
                            <p className="text-gray-600">קומה 5 עם נוף מדהים ופתוח</p>
                        </div>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4">
                        <div className="text-3xl">❄️</div>
                        <div>
                            <h3 className="font-bold text-lg text-blue-900">מיזוג אוויר</h3>
                            <p className="text-gray-600">6 מזגנים נפרדים לשליטה מושלמת בכל חלל</p>
                        </div>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4">
                        <div className="text-3xl">📞</div>
                        <div>
                            <h3 className="font-bold text-lg text-blue-900">תקשורת ואינטרקום</h3>
                            <p className="text-gray-600">מערכת אינטרקום חכמה: עמדה ראשית + 5 שלוחות (אחת בכל חדר)</p>
                        </div>
                    </div>

                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4">
                        <div className="text-3xl">✨</div>
                        <div>
                            <h3 className="font-bold text-lg text-blue-900">מצב הנכס</h3>
                            <p className="text-gray-600">מושקע, ייצוגי ומוכן לכניסה מיידית</p>
                        </div>
                    </div>
                </div>

                {/* VIDEO TOUR (Looping) */}
                <h2 className="text-3xl font-bold text-blue-900 mb-6 border-b-2 border-blue-100 pb-2">🎬 סיור וידאו במשרד</h2>
                <div className="mb-16 rounded-2xl overflow-hidden shadow-lg border border-gray-200">
                    <video
                        src="/office/office-tour.mp4"
                        autoPlay
                        loop
                        muted
                        playsInline
                        controls
                        className="w-full"
                        style={{ maxHeight: '550px', objectFit: 'cover', background: '#000' }}
                    />
                </div>

                {/* IMAGE GALLERY */}
                <h2 className="text-3xl font-bold text-blue-900 mb-6 border-b-2 border-blue-100 pb-2">📸 תמונות מהנכס</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-16">
                    {images.map((img, i) => (
                        <div
                            key={i}
                            className="bg-gray-200 rounded-lg overflow-hidden shadow-sm cursor-pointer group"
                            style={{ aspectRatio: '4/3' }}
                            onClick={() => setFullscreenImg(img.src)}
                        >
                            <img
                                src={img.src}
                                alt={img.alt}
                                className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-300"
                                onError={(e) => { e.target.src = `https://via.placeholder.com/600x400?text=${encodeURIComponent(img.alt)}`; }}
                            />
                        </div>
                    ))}
                </div>

                {/* LOCATION MAP */}
                <h2 className="text-3xl font-bold text-blue-900 mb-6 border-b-2 border-blue-100 pb-2">📍 מיקום המשרד</h2>
                <div className="mb-16 rounded-2xl overflow-hidden shadow-lg border border-gray-200" style={{ height: '400px' }}>
                    <iframe
                        title="מיקום המשרד"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1000!2d35.313278!3d32.700417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzLCsDQyJzAxLjUiTiAzNcKwMTgnNDcuOCJF!5e0!3m2!1siw!2sil!4v1700000000000"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>


                <div id="contact" className="bg-blue-50 border-2 border-blue-100 rounded-2xl p-8 text-center max-w-2xl mx-auto shadow-md">
                    <h2 className="text-2xl font-bold text-blue-900 mb-4">מעוניינים לשמוע עוד?</h2>
                    <p className="text-gray-700 mb-6">המשרד זמין לכניסה. צרו קשר לתיאום פגישה במקום.</p>
                    <div className="flex flex-col md:flex-row justify-center items-center gap-4">
                        <a href="tel:0524874031" className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-xl transition-colors w-full md:w-auto justify-center">
                            <span>📞</span> 052-487-4031
                        </a>
                        <a href="mailto:majd@alumnawatha.com" className="flex items-center gap-2 bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 font-bold py-3 px-6 rounded-lg text-xl transition-colors w-full md:w-auto justify-center">
                            <span>✉️</span> שלח אימייל
                        </a>
                    </div>
                </div>

            </div>

            {/* FULLSCREEN LIGHTBOX */}
            {fullscreenImg && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center"
                    style={{ background: 'rgba(0,0,0,0.92)' }}
                    onClick={() => setFullscreenImg(null)}
                >
                    {/* Close Button */}
                    <button
                        onClick={() => setFullscreenImg(null)}
                        className="absolute top-6 left-6 text-white text-4xl font-bold hover:text-red-400 transition-colors z-50"
                        style={{ lineHeight: 1 }}
                    >
                        ✕
                    </button>

                    {/* Previous Arrow */}
                    <button
                        onClick={(e) => { e.stopPropagation(); navigateImage(-1); }}
                        className="absolute right-6 text-white text-5xl font-bold hover:text-yellow-400 transition-colors z-50 select-none"
                        style={{ top: '50%', transform: 'translateY(-50%)' }}
                    >
                        ❯
                    </button>

                    {/* Next Arrow */}
                    <button
                        onClick={(e) => { e.stopPropagation(); navigateImage(1); }}
                        className="absolute left-6 text-white text-5xl font-bold hover:text-yellow-400 transition-colors z-50 select-none"
                        style={{ top: '50%', transform: 'translateY(-50%)' }}
                    >
                        ❮
                    </button>

                    {/* Image */}
                    <img
                        src={fullscreenImg}
                        alt="תמונה מוגדלת"
                        className="max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    />

                    {/* Image Counter */}
                    <div className="absolute bottom-6 text-white text-lg font-bold bg-black bg-opacity-50 px-4 py-1 rounded-full">
                        {images.findIndex(img => img.src === fullscreenImg) + 1} / {images.length}
                    </div>
                </div>
            )}
        </div>
    );
}